import { CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

/**
 * Night Cut — gift box tick box in the cart.
 * Adds/removes the gift box as a nested cart line, then lets Horizon's
 * cart-items-component and cart icon re-render from the returned sections.
 */
class NcGiftBox extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.input?.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.#onChange);
  }

  #onChange = async () => {
    const adding = this.input.checked;
    this.input.disabled = true;

    const sections = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean)
      .join(',');

    const url = adding ? Theme.routes.cart_add_url : Theme.routes.cart_change_url;
    const body = adding
      ? {
          items: [{ id: Number(this.dataset.giftVariant), quantity: 1, parent_line_key: this.dataset.lineKey }],
          sections,
          sections_url: window.location.pathname,
        }
      : { id: this.dataset.giftKey, quantity: 0, sections, sections_url: window.location.pathname };

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: adding ? 'add' : 'remove',
        context: 'cart',
        lines: [{ id: adding ? this.dataset.giftVariant : this.dataset.giftKey, quantity: adding ? 1 : 0 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(url, fetchConfig('json', { body: JSON.stringify(body) }));
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not update gift box');

      const cart = await (await fetch(`${Theme.routes.cart_url}.js`)).json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections: data.sections, itemCount: cart.item_count, source: 'nc-gift-box', didError: false },
      });
    } catch (error) {
      console.error(error);
      this.input.checked = !adding;
      this.input.disabled = false;
      deferred.reject(error);
    }
  };
}

if (!customElements.get('nc-gift-box')) customElements.define('nc-gift-box', NcGiftBox);
